export const ICONS_WHO_SHOULD_USE = [
  'https://assets1.cleartax-cdn.com/cleartax/images/1675230459_icon1.svg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1675230731_group1000001928.svg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1675230801_group1000002464.svg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1675230910_group1000002463.svg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1675231059_group1000002465.svg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1675231122_group1000002497.svg',
  'https://assets1.cleartax-cdn.com/cleartax/images/1675231176_icons.svg',
];
